module.exports = __webpack_public_path__ + "static/media/search-icon.c77510fb.svg";